/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CategoryDto } from '../models/category-dto';
import { CategoryRefDto } from '../models/category-ref-dto';
import { PagedCategoryDto } from '../models/paged-category-dto';
import { PagedProductDto } from '../models/paged-product-dto';
import { ProductIntensityDto } from '../models/product-intensity-dto';
import { SegmentEnum } from '../models/segment-enum';

@Injectable({
  providedIn: 'root',
})
export class CategoryService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTopCategories
   */
  static readonly GetTopCategoriesPath = '/categories';

  /**
   * Get top level categories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTopCategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTopCategories$Response(params: {
    pageIndex: number;
    pageSize: number;
  }): Observable<StrictHttpResponse<PagedCategoryDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoryService.GetTopCategoriesPath, 'get');
    if (params) {
      rb.query('pageIndex', params.pageIndex, {});
      rb.query('pageSize', params.pageSize, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PagedCategoryDto>;
      })
    );
  }

  /**
   * Get top level categories.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTopCategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTopCategories(params: {
    pageIndex: number;
    pageSize: number;
  }): Observable<PagedCategoryDto> {

    return this.getTopCategories$Response(params).pipe(
      map((r: StrictHttpResponse<PagedCategoryDto>) => r.body as PagedCategoryDto)
    );
  }

  /**
   * Path part for operation getCategoryById
   */
  static readonly GetCategoryByIdPath = '/categories/{id}';

  /**
   * Get category by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCategoryById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCategoryById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<CategoryDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoryService.GetCategoryByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CategoryDto>;
      })
    );
  }

  /**
   * Get category by id.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getCategoryById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCategoryById(params: {
    id: string;
  }): Observable<CategoryDto> {

    return this.getCategoryById$Response(params).pipe(
      map((r: StrictHttpResponse<CategoryDto>) => r.body as CategoryDto)
    );
  }

  /**
   * Path part for operation getSubcategories
   */
  static readonly GetSubcategoriesPath = '/categories/{id}/categories';

  /**
   * Get sub categories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubcategories()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubcategories$Response(params: {
    id: string;
    pageIndex: number;
    pageSize: number;
  }): Observable<StrictHttpResponse<PagedCategoryDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoryService.GetSubcategoriesPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('pageIndex', params.pageIndex, {});
      rb.query('pageSize', params.pageSize, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PagedCategoryDto>;
      })
    );
  }

  /**
   * Get sub categories.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSubcategories$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSubcategories(params: {
    id: string;
    pageIndex: number;
    pageSize: number;
  }): Observable<PagedCategoryDto> {

    return this.getSubcategories$Response(params).pipe(
      map((r: StrictHttpResponse<PagedCategoryDto>) => r.body as PagedCategoryDto)
    );
  }

  /**
   * Path part for operation getProductInCategory
   */
  static readonly GetProductInCategoryPath = '/categories/{id}/products';

  /**
   * Get products in category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductInCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductInCategory$Response(params: {
    id: string;
    segment?: Array<SegmentEnum>;
    starRating?: Array<number>;
    feature?: Array<string>;
    language?: Array<string>;
    currentCompany?: boolean;
    pageIndex: number;
    pageSize: number;

    /**
     * Use field names from the ProductDTO
     */
    orderBy: string;
  }): Observable<StrictHttpResponse<PagedProductDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoryService.GetProductInCategoryPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('segment', params.segment, {});
      rb.query('starRating', params.starRating, {});
      rb.query('feature', params.feature, {});
      rb.query('language', params.language, {});
      rb.query('currentCompany', params.currentCompany, {});
      rb.query('pageIndex', params.pageIndex, {});
      rb.query('pageSize', params.pageSize, {});
      rb.query('orderBy', params.orderBy, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PagedProductDto>;
      })
    );
  }

  /**
   * Get products in category.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductInCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductInCategory(params: {
    id: string;
    segment?: Array<SegmentEnum>;
    starRating?: Array<number>;
    feature?: Array<string>;
    language?: Array<string>;
    currentCompany?: boolean;
    pageIndex: number;
    pageSize: number;

    /**
     * Use field names from the ProductDTO
     */
    orderBy: string;
  }): Observable<PagedProductDto> {

    return this.getProductInCategory$Response(params).pipe(
      map((r: StrictHttpResponse<PagedProductDto>) => r.body as PagedProductDto)
    );
  }

  /**
   * Path part for operation getProductIntensities
   */
  static readonly GetProductIntensitiesPath = '/categories/{id}/intensities';

  /**
   * Get product intensities.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductIntensities()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductIntensities$Response(params: {
    id: string;
    productId: Array<string>;
  }): Observable<StrictHttpResponse<Array<ProductIntensityDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CategoryService.GetProductIntensitiesPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('productId', params.productId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ProductIntensityDto>>;
      })
    );
  }

  /**
   * Get product intensities.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductIntensities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductIntensities(params: {
    id: string;
    productId: Array<string>;
  }): Observable<Array<ProductIntensityDto>> {

    return this.getProductIntensities$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ProductIntensityDto>>) => r.body as Array<ProductIntensityDto>)
    );
  }

  /**
   * Path part for operation getProductFeaturesInCategory
   */
  static readonly GetProductFeaturesInCategoryPath = '/categories/{id}/features';

  /**
   * Get features of products in category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductFeaturesInCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductFeaturesInCategory$Response(params: {
    id: string;
    limit?: number;
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, CategoryService.GetProductFeaturesInCategoryPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * Get features of products in category.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductFeaturesInCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductFeaturesInCategory(params: {
    id: string;
    limit?: number;
  }): Observable<Array<string>> {

    return this.getProductFeaturesInCategory$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * Path part for operation getProductLanguagesInCategory
   */
  static readonly GetProductLanguagesInCategoryPath = '/categories/{id}/languages';

  /**
   * Get languages of products in category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductLanguagesInCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductLanguagesInCategory$Response(params: {
    id: string;
    limit?: number;
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, CategoryService.GetProductLanguagesInCategoryPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * Get languages of products in category.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductLanguagesInCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductLanguagesInCategory(params: {
    id: string;
    limit?: number;
  }): Observable<Array<string>> {

    return this.getProductLanguagesInCategory$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * Path part for operation getTopCategoriesByCategories
   */
  static readonly GetTopCategoriesByCategoriesPath = '/categories/top-by-categories';

  /**
   * Get top level categories of categories.
   *
   * This method is intended to show filters at the top of the techstack editor
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTopCategoriesByCategories()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTopCategoriesByCategories$Response(params: {
    body: Array<string>
  }): Observable<StrictHttpResponse<Array<CategoryRefDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CategoryService.GetTopCategoriesByCategoriesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CategoryRefDto>>;
      })
    );
  }

  /**
   * Get top level categories of categories.
   *
   * This method is intended to show filters at the top of the techstack editor
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTopCategoriesByCategories$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getTopCategoriesByCategories(params: {
    body: Array<string>
  }): Observable<Array<CategoryRefDto>> {

    return this.getTopCategoriesByCategories$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CategoryRefDto>>) => r.body as Array<CategoryRefDto>)
    );
  }

  /**
   * Path part for operation getAllSubCategoriesByCategories
   */
  static readonly GetAllSubCategoriesByCategoriesPath = '/categories/child-by-categories';

  /**
   * Get ALL child categories of categories.
   *
   * This method is intended to be used for show/hide categories on tech stack editor according to filter selected
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSubCategoriesByCategories()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAllSubCategoriesByCategories$Response(params: {
    body: Array<string>
  }): Observable<StrictHttpResponse<Array<CategoryRefDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CategoryService.GetAllSubCategoriesByCategoriesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CategoryRefDto>>;
      })
    );
  }

  /**
   * Get ALL child categories of categories.
   *
   * This method is intended to be used for show/hide categories on tech stack editor according to filter selected
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllSubCategoriesByCategories$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAllSubCategoriesByCategories(params: {
    body: Array<string>
  }): Observable<Array<CategoryRefDto>> {

    return this.getAllSubCategoriesByCategories$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CategoryRefDto>>) => r.body as Array<CategoryRefDto>)
    );
  }

}
